import { DashboardAccordionComponent } from './dashboard-details/dashboard-accordion/dashboard-accordion.component';
import { DashboardBannerComponent } from './dashboard-details/dashboard-banner/dashboard-banner.component';
import { DashboardChartsComponent } from './dashboard-details/dashboard-charts/dashboard-charts.component';
import { DashboardDetailsComponent } from './dashboard-details/dashboard-details.component';
import { DashboardDropdownComponent } from './dashboard-details/dashboard-dropdown/dashboard-dropdown.component';
import { DashboardNoPaystubsComponent } from './dashboard-details/dashboard-no-paystubs/dashboard-no-paystubs.component';

export const components = [
  DashboardAccordionComponent,
  DashboardBannerComponent,
  DashboardChartsComponent,
  DashboardDetailsComponent,
  DashboardDropdownComponent,
  DashboardNoPaystubsComponent,
];

export * from './dashboard-details/dashboard-accordion/dashboard-accordion.component';
export * from './dashboard-details/dashboard-banner/dashboard-banner.component';
export * from './dashboard-details/dashboard-charts/dashboard-charts.component';
export * from './dashboard-details/dashboard-details.component';
export * from './dashboard-details/dashboard-dropdown/dashboard-dropdown.component';
export * from './dashboard-details/dashboard-no-paystubs/dashboard-no-paystubs.component';
